// driverDetails.js
import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Button, FormControl,Menu, FormControlLabel, FormLabel, Grid, Grid2, IconButton, MenuItem, Modal, Paper, Radio, RadioGroup, Select, Snackbar, Tab, Tabs, TextareaAutosize, TextField, Typography } from '@mui/material';
import Navbar from '../navbar/Navbar.jsx';
import Sidemenu from '../sidemenu/Sidemenu';
import './driverDetails.css';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import starIcon from '../../assets/icons/starIcon.png';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import defaultImg from '../../assets/images/defaultimg.png';
import altProfile from '../../assets/images/altProfile.png';
import verifiedTick from '../../assets/images/verifiedTick.png';
import rejectedCross from '../../assets/images/rejectedCross.png';
import axios from 'axios';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import TokenError from '../tokenError.jsx';
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Label } from 'flowbite-react';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import PhoneInput from 'react-phone-number-input';
import { parsePhoneNumber } from 'libphonenumber-js';
import {CustomSwitch }from "../ui/Toggle.jsx";
import DefaultCar from "../../assets/icons/blueCar.svg";
import { bgcolor } from '@mui/system';
import threedots from "../../assets/icons/threedots.svg";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import RotateRightIcon from '@mui/icons-material/RotateRight';

function CustomTabPanel(props) {
    // console.log(props)
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  }
  
  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };
  
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  
const DriverDetails = () => {

    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const [rows, setRows] = useState([]);
    const location = useLocation();
    const [value, setValue] = useState(0);
    const [driverDocumentsData, setDriverDocumentsData] = useState([]);
    const navigate = useNavigate();
    const [carDetailsData, setCarDetailsData] = useState([]);
    const [rejectModal, setRejectModal] = useState(false);
    const [rejectValue, setRejectValue] = useState('');
    const [customReason, setCustomReason] = useState('');
    const [modalData, setModalData] = useState({ vehicleId: null, documentId: null, status: 3, reason: '' });
    const [documentType, setDocumentType] = useState(''); 

    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [open, setOpen] = useState(false);
    const [currentImage, setCurrentImage] = useState(null);
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [openAttachmentVehicle, setOpenAttachmentVehicle] = useState(false);
    const [attachmentVehicleId, setAttachmentVehicleId] = useState('');
    const [availableVehicle, setAvailableVehicle] = useState([]);
    const [newDriverVehicle, setNewDriverVehicle] = useState('');
    const [showEditIcon, setShowEditIcon] = useState(false);
    const [editingDocId, setEditingDocId] = useState(null);
    const [editedDriverEmail, setEditedDriverEmail] = useState('');
    const [editedDriverName, setEditedDriverName] = useState('');
    const [editedDriverImage, setEditedDriverImage] = useState('');
    const [editedDriverDob, setEditedDriverDob] = useState(dayjs());
    const [editedDriverPhone, setEditedDriverPhone] = useState('');
    const [editedDriverCountryCode, setEditedDriverCountryCode] = useState('');
    const [editedDriverExpireDate, setEditedDriverExpireDate] = useState(dayjs());
    const [emailError, setEmailError] = useState(false);

    const [driverName, setDriverName] = useState('');
    const [driverId, setDriverId] = useState('');
    const [driverPhone, setDriverPhone] = useState('');
    const [driverEmail, setDriverEmail] = useState('');
    const [driverImage, setDriverImage] = useState('');
    const [driverRating, setDriverRating] = useState('');
    const [driverCurrentStatus, setDriverCurrentStatus] = useState('');
    const [driverDob, setDriverDob] = useState(dayjs());
    const [driverCountryCode, setDriverCountryCode] = useState('');
    const [multipleVehicletoggle, setMultipleVehicletoggle] = useState();
    const [isAttachmentEnabled, setIsAttachmentEnabled] = useState(false);
    const [deletSelectedVehicleId, setDeleteVehicleId] = useState();
    const [rotation, setRotation] = useState(0);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const openMenu = Boolean(anchorEl);
    const vehicleDecouplingEnabled = localStorage.getItem('is_vehicle_decoupling_enabled');
    const driverDataShown = localStorage.getItem('hidedriverinfo');

    const driver_vehicle_attachment_enabled = localStorage.getItem('driver_vehicle_attachment_enabled');
    const date_format_dd_mm_yy = localStorage.getItem('date_format_dd_mm_yy');
    let permissions = [];

    try {
      const stored = localStorage.getItem('clientTabPermission');
      permissions = stored ? JSON.parse(stored) : [];
      if (!Array.isArray(permissions)) {
        permissions = [];
      }
    } catch (error) {
      console.error("Invalid clientTabPermission in localStorage:", error);
      permissions = [];
    }

    const customerTab = permissions.find(p => p.tab_id === 40);

    // Check if permission "1" exists
        const hasPermission2 = customerTab?.permissions?.split(',').includes("2");

    const handleImageOpen = (image) => {
        setCurrentImage(image);
        setRotation(0);
        setOpen(true);
    };

    const handleImageClose = () => {
        setOpen(false);
        setCurrentImage(null);
    };

    const clientCities = JSON.parse(localStorage.getItem("cities")) || [];
    
    const handleRejectChange = (event) => {
        setRejectValue(event.target.value);
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
        // Fetch car details data when switching to the Documents tab (index === 0)
        if (newValue === 0 && driverId) {
            fetchCarDetailsData();  // Call API when Documents tab is selected
        }
    };

    useEffect(() => {
        if (location.state?.rowData) {
            const rowData = location.state?.rowData;
            console.log('location.state?.rowData=', rowData);
            setDriverName(rowData.driver_name);
            setDriverId(rowData.driver_id);
            setDriverPhone(rowData.phone_number);
            setDriverEmail(rowData.email);
            setDriverImage(rowData.driver_image || '');
            setDriverRating(rowData.driver_rating);
            setDriverCurrentStatus(rowData.driver_current_status);

            setEditedDriverEmail(rowData.email);
            setEditedDriverName(rowData.driver_name);
            setEditedDriverImage(rowData.driver_image || '');
            setEditedDriverPhone(rowData.phone_number);
            setEditedDriverCountryCode(rowData.country_code);
        }
    }, [location.state]);

    useEffect(() => {
        // Call the API when the component first mounts (page loads)
        // fetchCarDetailsData();
        fetchAvailableVehicles();
        
        // Load persisted driver information from localStorage if available
        const savedDriverName = localStorage.getItem('driver_name');
        const savedDriverEmail = localStorage.getItem('driver_email');
        const savedDriverImage = localStorage.getItem('driver_image');
        const savedDriverDob = localStorage.getItem('driver_dob');
        const savedDriverId = localStorage.getItem('driver_id');
        const savedDriverPhone = localStorage.getItem('phone_number');
        const savedDriverCountryCode = localStorage.getItem('country_code');
        
        if (savedDriverName) {
            setDriverName(savedDriverName);
        }
        
        if (savedDriverEmail) {
            setDriverEmail(savedDriverEmail);
        }
        
        if (savedDriverImage) {
            setDriverImage(savedDriverImage);
        }

        if (savedDriverDob) {
            setDriverDob(savedDriverDob);
        }

        if (savedDriverId) {
            setDriverId(savedDriverId);
        }

        if (savedDriverPhone) {
            setDriverPhone(savedDriverPhone);
        }

        if (savedDriverCountryCode) {
            setDriverCountryCode(savedDriverCountryCode);
        }
    }, []);  

    useEffect(() => {
        if(driverId){
            fetchCarDetailsData();
        }
    }, [driverId]);

    const handleTextAreaChange = (event) => {
        setCustomReason(event.target.value);
    };
    const cityFilter = location.state?.cityFilter;

    const fetchCarDetailsData = async () => {
        try {
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();

            const url = `${serverUrl}/driver/get_details`;
            const obj={
                token: token, timestamp: timestamp, driver_id: driverId,
            }

            const response =  await makeGetRequestToUrl(url, obj);

            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }

            if(response.flag == 200){
                const driversData = response.data;
                console.log('driversData.vehicle_details = ', driversData.vehicle_details)
                setCarDetailsData(driversData.vehicle_details)
                setDriverDocumentsData(driversData.driver_documents);
                setMultipleVehicletoggle(driversData.is_allow_new_vehicle);
                setIsAttachmentEnabled(driversData.is_attachment_enabled)
            }
            else {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    // Handle reject modal open
    const handleRejectModal = (documentId, vehicleId, status, docType) => {
        setModalData({ documentId, vehicleId, status, docType});
        setRejectModal(true);
    };

    const handleMultipleVehiclePermission = () =>{
        try {
        const token = localStorage.getItem('token');
        const payload ={
            token,
            driver_id:driverId,
            is_allow_new_vehicle:multipleVehicletoggle ? 1 : 0,
        }
        const url = `${operationsUrl}/driver/set_new_vehicle_permission`; 
        const response = makePostRequestToUrl(url,payload);
        console.log(response,"response");
        } catch (error) {
            console.error(error);
        }
    }

    const handleDefaultVehicleset = async (vehicle_id) => {
        try {
            const token = localStorage.getItem('token');
            const payload = {
                token,
                driver_id: driverId,
                vehicle_id: vehicle_id,
            }
            const url = `${operationsUrl}/driver/set_default_vehicle`; 
            const response = await makePostRequestToUrl(url, payload);
            console.log(response, "response");
            
            if (response.flag === 200) {
                await fetchCarDetailsData();
                setMessage("Primary vehicle set successfully");
                showSnackbar(true);
            } else {
                setMessage(response.message || "Failed to set primary vehicle");
                showSnackbar(true);
            }
        } catch (error) {
            console.error(error);
            setMessage("Error setting primary vehicle");
            showSnackbar(true);
        }
    }
    
    useEffect(()=>{
        handleMultipleVehiclePermission();
    },[multipleVehicletoggle]);

    const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
    setAnchorEl(null);
    };

    const handleDeleteVehicle = async()=>{
        try {
            const token = localStorage.getItem('token');
            const url = `${operationsUrl}/driver/delete_vehicle`;
            const obj = {
                token,
                driver_id:driverId,
                vehicle_id:deletSelectedVehicleId,
            }
            const response = await makePostRequestToUrl(url, obj);
            if (response.flag === 200) {
                await fetchCarDetailsData();
                setMessage("Vehicle deleted successfully");
                showSnackbar(true);
            } else {
                setMessage(response.message || "Failed to Delete vehicle");
                showSnackbar(true);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const handleDelete = () => {
    handleDeleteVehicle()
    handleMenuClose();
    
    };

    const onClose = () => {
        setRejectModal(false);
        setRejectValue('');
        setCustomReason('');
    };

    const handleRejectSubmit = async (documentId, vehicleId, status, docType) => {

        try {
            const token = localStorage.getItem('token');
            const finalReason = customReason || rejectValue;
    
            // Check if it's a vehicle or driver document
            if (docType === 'vehicle') {
                console.log("Submitting Vehicle Document Approval/Rejection");

                // const url = `${operationsUrl}/vehicle/documents/verify`;
                // const obj={
                //     token: token,
                //     vehicle_id: vehicleId,   // Pass vehicle ID if it's a vehicle document
                //     document_id: documentId, // Pass document ID
                //     status: status,          // Pass the status (1 = approve, 3 = reject)
                //     reason: finalReason,     // Only include reason if it's a reject
                // }

                // const response =  await makePostRequestToUrl(url, obj);

                // console.log('response = ', response)

                const response = await axios.post(operationsUrl + '/vehicle/documents/verify', {
                    token: token,
                    vehicle_id: vehicleId,   // Pass vehicle ID if it's a vehicle document
                    document_id: documentId, // Pass document ID
                    status: status,          // Pass the status (1 = approve, 3 = reject)
                    reason: finalReason,     // Only include reason if it's a reject
                });

                if(response.data.flag==102){
                    console.log('Token is expired. Please login again')
                    localStorage.removeItem('token');
                    setErrorMessage('Your session has expired. Please log in again.');
                    setTokenExpired(true);

                    setTimeout(() => {
                        navigate('/signup');
                    }, 2000);
                }
                if (response.status === 200) {
                    fetchCarDetailsData(); // Reload the data
                }
            } else if (docType === 'driver') {
                const response = await axios.post(operationsUrl + '/driver/documents/verify', {
                    token: token,
                    driver_id: driverId,           // Use the driver's ID
                    document_id: documentId,       // Pass document ID
                    status: status,                // Pass the status (1 = approve, 3 = reject)
                    reason: finalReason,           // Only include reason if it's a reject
                });
                if(response.data.flag==102){
                    console.log('Token is expired. Please login again')
                    localStorage.removeItem('token');
                    setErrorMessage('Your session has expired. Please log in again.');
                    setTokenExpired(true);

                    setTimeout(() => {
                        navigate('/signup');
                    }, 2000);
                }
                if (response.status === 200) {
                    fetchCarDetailsData(); // Reload the data
                }
            }
        } catch (error) {
            console.error('Error handling approve/reject:', error);
        }
    };

    const detachVehicle = async() => {
        const token = localStorage.getItem('token');
        const payload = {
            token: token,
            driver_id: driverId,
            vehicle_id: carDetailsData[0].vehicle_id,
            is_active: 0
        };
        try {
            const url = operationsUrl + '/driver/vehicle_attachment';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);

            } else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            console.error('Error: ', error);
            setMessage(error);
        }
        fetchCarDetailsData();
    }

    const attachVehicle = () => {
        setOpenAttachmentVehicle(true);
        fetchAvailableVehicles();
        // attachVehicleById();
    }

    const attachVehicleById = async() => {
        const token = localStorage.getItem('token');
        const payload = {
            token: token,
            driver_id: driverId,
            vehicle_id: newDriverVehicle,
            is_active: 1
        };
        try {
            const url = operationsUrl + '/driver/vehicle_attachment';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);

            } else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            console.error('Error: ', error);
            setMessage(error);
        }
        fetchCarDetailsData();
        setOpenAttachmentVehicle(false)
    }

    const fetchAvailableVehicles = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/panel/fetch_available_vehicles';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                // Filter active vehicles
                const activeVehicles = response.data;
                // console.log('response.data[0] = ', activeVehicles[0].vehicle_type)
                setAvailableVehicle(activeVehicles);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
  
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    const handleWhatsAppClick = () => {
        window.open(`https://wa.me/${driverPhone}`);
    };

    const startEditingFields = () => {
        console.log('driverDob = ', driverDob)
        setShowEditIcon(true);
        setEditedDriverEmail(driverEmail);
        setEditedDriverName(driverName);
        setEditedDriverDob(driverDob);
        setEditedDriverImage(driverImage);
        setEditedDriverCountryCode(driverCountryCode);
        setEditedDriverPhone(driverPhone);
        setEmailError(false); // Reset error state when starting edit
    }

    const stopEditingFields = () => {
        setShowEditIcon(false);
        setEditedDriverEmail(driverEmail); // Restore original value instead of empty string
        setEditedDriverDob(driverDob); // Restore original value instead of empty string
        setEditedDriverName(driverName);   // Restore original value instead of empty string
        setEditedDriverImage(driverImage); // Restore original value instead of empty string
        setEditedDriverPhone(driverPhone); // Restore original value instead of empty string
        setEditedDriverCountryCode(driverCountryCode); // Restore original value instead of empty string
        setEmailError(false);             // Reset error state when cancelling
    }

    const saveDriverInfo = async(row, status) => {
        const token = localStorage.getItem('token');
        if(emailError){
            setMessage('Valid email is required.');
            showSnackbar(true);
            return;
        }

        if(editedDriverEmail==driverEmail && editedDriverName==driverName && editedDriverDob==driverDob && editedDriverImage==driverImage && editedDriverPhone==driverPhone){
            setMessage('Nothing to update.')
            showSnackbar(true);
            setShowEditIcon(false);
            return;
        }
        
        const payload = {
            token: token,
            driver_id: driverId
        };
        if(editedDriverEmail && editedDriverEmail!=driverEmail){
            payload.email = editedDriverEmail;
        }
        if(editedDriverName && editedDriverName!=driverName){
            payload.driver_name = editedDriverName;
        }
        if(editedDriverDob && editedDriverDob !== 'null' && editedDriverDob!=driverDob){
            console.log('here')
            payload.date_of_birth = editedDriverDob ? dayjs(editedDriverDob).format('YYYY-MM-DD') : null;
        }
        if(editedDriverImage && editedDriverImage!=driverImage){
            payload.driver_image = editedDriverImage;
        }
        if(editedDriverPhone && driverPhone!=editedDriverPhone){
            payload.phone_number = editedDriverPhone;
        }
        // if(editedDriverCountryCode && driverCountryCode!=editedDriverCountryCode){
        //     payload.country_code = editedDriverCountryCode;
        // }
        try {
            const url = operationsUrl + '/driver/update_driver_details';
            const response = await makePostRequestToUrl(url, payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                // stopEditingFields();
                setShowEditIcon(false);
                
                // Update localStorage
                localStorage.setItem('driver_name', editedDriverName);
                localStorage.setItem('driver_email', editedDriverEmail);
                if(editedDriverImage) {
                    localStorage.setItem('driver_image', editedDriverImage);
                }
                localStorage.setItem('date_of_birth', editedDriverDob);
                localStorage.setItem('phone_number', editedDriverPhone);
                localStorage.setItem('country_code', editedDriverCountryCode);
                
                // Update the state variables with the new values
                setDriverName(editedDriverName);
                setDriverDob(editedDriverDob);
                setDriverEmail(editedDriverEmail);
                if(editedDriverImage) {
                    setDriverImage(editedDriverImage);
                }
                setDriverPhone(editedDriverPhone);
                setDriverCountryCode(editedDriverCountryCode);
            } else if(response.flag === 102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
  
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
            else {
                setMessage(response.message)
                showSnackbar(true);
            }
        } catch (error) {
            console.error('Error while deactivating:', error);
            setMessage(error);
        }
    }

    const handleImageUpload = async(e) => {
        const file = e.target.files[0];
        if (file) {
            // setHealthCardImageUrl(URL.createObjectURL(file));
            const formData = new FormData();
            formData.append('image', file);
    
            try {
                const response = await axios.post(operationsUrl + '/upload_image', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });
    
                const s3Url = response.data.url;
                const newImage = {
                    name: file.name,
                    src: s3Url,
                    isUploaded: true,
                };
                setEditedDriverImage(s3Url);
                // setHealthCardImage(file);
            } catch (error) {
                console.error('Error uploading image:', error);
            }
        }
    };

    const validateEmail = (value) => {
        const re = /^(([^<>()\[\]\\.,;:\s@\"]+(\.[^<>()\[\]\\.,;:\s@\"]+)*)|(".+"))@(([^<>()[\]\\.,;:\s@\"]+\.)+[^<>()[\]\\.,;:\s@\"]{2,})$/i;
        return re.test(String(value).toLowerCase());
    };

    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEditedDriverEmail(value);
        setEmailError(!validateEmail(value));
    };

    const handleExpireDateSubmit = async (docId, vehicleId) => {
        const token = localStorage.getItem('token');
        const payload = {
            token: token,
            driver_id: driverId,
            document_id: docId,
            expiry_date: dayjs(editedDriverExpireDate).format('YYYY-MM-DD')
        };
        if(vehicleId){
            payload.vehicle_id = vehicleId;
        }
        
        try {
            const url = operationsUrl + '/edit_expiry_date';
            const response = await makePostRequestToUrl(url, payload);
            if (response.flag === 200) {
                setMessage(response.message);
                showSnackbar(true);
                // setShowExpireEditIcon(false);
                setEditingDocId(null);
                fetchCarDetailsData();
            } else {
                setMessage(response.message || 'Failed to update expiry date');
                showSnackbar(true);
            }
        } catch (error) {
            console.error('Error: ', error);
            setMessage(error.message || 'An error occurred while updating expiry date');
            showSnackbar(true);
        }
    }

    return (
        <div>
            {tokenExpired && (<TokenError/>)}
            <div style={{minHeight: '100vh'}}>
            
                <Typography style={{ fontSize: '28px', fontWeight: '500' }}>User</Typography>
                <Typography style={{ color: '#83888E'}}>User / Driver / Driver Details</Typography>

                <Grid2 className="mainBox">
                    <Grid2 container className="innerOne" size={12}>
                        <Grid2 item size={showEditIcon ? 1.4 : 2} sx={{margin:'20px'}}>
                            <Box sx={{display:'flex'}}>
                                <Grid2>
                                    <Box sx={{ position: 'relative' }}>
                                        {editedDriverImage && !showEditIcon && (
                                            <img className="profileBox" src={editedDriverImage} alt="profile" width='80px' height='80px'/>
                                        )}
                                        {editedDriverImage=="" && !showEditIcon && (
                                            <img className="profileBox" src={altProfile} alt="alt profile" width='80px' height='80px'/>
                                        )}
                                        {showEditIcon && (
                                            <>
                                                <img 
                                                    className="profileBox" 
                                                    src={editedDriverImage || driverImage || altProfile} 
                                                    alt="profile" 
                                                    width='80px' 
                                                    height='80px' 
                                                    style={{ filter: 'blur(1px)', opacity: 0.8 }}
                                                />
                                                <Box 
                                                    onClick={() => document.getElementById('imageUpload').click()}
                                                    sx={{ 
                                                        position: 'absolute', 
                                                        top: 0, 
                                                        left: 0, 
                                                        width: '80px', 
                                                        height: '80px', 
                                                        display: 'flex', 
                                                        justifyContent: 'center', 
                                                        alignItems: 'center',
                                                        backgroundColor: 'rgba(0,0,0,0.2)',
                                                        borderRadius: '8px',
                                                        cursor: 'pointer'
                                                    }}
                                                >
                                                    <EditIcon sx={{ color: 'black', fontSize: '24px', backgroundColor: 'white', borderRadius: '8px' }}/>
                                                </Box>
                                                <input
                                                    id="imageUpload"
                                                    type="file"
                                                    accept="image/*"
                                                    style={{ display: 'none' }}
                                                    onChange={handleImageUpload}
                                                />
                                            </>
                                        )}
                                    </Box>
                                </Grid2>
                                
                            </Box>
                            {showEditIcon && (
                                <TextField
                                variant="outlined"
                                value={editedDriverName}
                                onChange={(e) => setEditedDriverName(e.target.value)}
                                InputProps={{
                                    inputProps: { min: 0 },
                                    style: {height: '36px', fontSize: '16px', padding: '14px 0px',backgroundColor:'#fff', borderRadius:'8px'}
                                }}
                            />
                            )}
                            {!showEditIcon && (
                                <Typography sx={{mt:'4px'}}>{driverName}</Typography>
                            )}
                            <Typography sx={{mt:'4px'}}>
                                {[...Array(5)]?.map((_, index) => (
                                    <span key={index}>
                                        {index < parseFloat(driverRating).toFixed(2) ? 
                                        <img src={starIcon} height="12px" width="12px" style={{marginRight:'1%'}} />
                                            : ' '}
                                    </span>
                                ))}
                                {/* <span style={{color:'#83888E', fontSize:'14px'}}>(50 reviews)</span> */}
                            </Typography>
                        </Grid2>
                        {/* <Grid2 item lg={3}></Grid2> */}
                        <Grid2 item size={showEditIcon ? 10 : 9.5}>
                            <Grid2 container item sx={{marginTop:'24px', justifyContent:'flex-end'}}>
                                <Button
                                    variant="contained"
                                    style={{
                                        backgroundColor: driverCurrentStatus==0 ? '#F9E9E9' : '#E7F8F2',
                                        color: driverCurrentStatus==0 ? '#D14545' : '#0DBA78',
                                        textTransform: 'none',
                                        pointerEvents: 'none',
                                        borderRadius: '6px',
                                        minWidth: '60px',
                                        border:'none',
                                        boxShadow: 'none',
                                        fontFamily: 'Poppins',
                                        border: driverCurrentStatus==0 ? '1px solid #D14545' : '1px solid#36C68F',
                                        height:'30px'
                                    }}
                                >
                                    <FiberManualRecordIcon style={{ fontSize: '12px' }}/> {driverCurrentStatus == 0 ? 'Offline' : 'Online'}
                                </Button>
                                <Button onClick={handleWhatsAppClick}
                                    variant="contained"
                                    style={{
                                        backgroundColor: '#25D366',
                                        color: '#fff',
                                        textTransform: 'none',
                                        borderRadius: '6px',
                                        minWidth: '40px',
                                        border:'none',
                                        boxShadow: 'none',
                                        fontFamily: 'Poppins',
                                        height:'30px',
                                        marginLeft:'1%',
                                        padding:'4px'
                                    }}
                                >
                                    <WhatsAppIcon style={{ fontSize: '26px' }}/>
                                </Button>
                                {!showEditIcon && hasPermission2 &&
                                    <Button 
                                        onClick={startEditingFields}
                                        variant="contained"
                                        style={{
                                            // backgroundColor: '#000',
                                            color: '#fff',
                                            textTransform: 'none',
                                            borderRadius: '6px',
                                            minWidth: '40px',
                                            border:'none',
                                            boxShadow: 'none',
                                            fontFamily: 'Poppins',
                                            height:'30px',
                                            marginLeft:'1%',
                                            padding:'4px',
                                        }}
                                    >
                                        <EditIcon style={{ fontSize: '26px' }}/>
                                    </Button>
                                }
                                
                                {showEditIcon && (
                                    <Button 
                                        onClick={saveDriverInfo}
                                        variant="contained"
                                        style={{
                                            // backgroundColor: '#000',
                                            color: '#fff',
                                            textTransform: 'none',
                                            borderRadius: '6px',
                                            minWidth: '40px',
                                            border:'none',
                                            boxShadow: 'none',
                                            fontFamily: 'Poppins',
                                            height:'30px',
                                            marginLeft:'1%',
                                            padding:'4px',
                                        }}
                                    >
                                        Save
                                    </Button>
                                )}
                                {showEditIcon && (
                                    <Button 
                                        onClick={stopEditingFields}
                                        variant="contained"
                                        style={{
                                            // backgroundColor: '#000',
                                            color: '#fff',
                                            textTransform: 'none',
                                            borderRadius: '6px',
                                            minWidth: '40px',
                                            border:'none',
                                            boxShadow: 'none',
                                            fontFamily: 'Poppins',
                                            height:'30px',
                                            marginLeft:'1%',
                                            padding:'4px',
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                )}
                            </Grid2>

                            <Grid2 container item spacing={5}  sx={{ marginTop:'46px', justifyContent:'right', marginBottom:'12px'}}>
                                <Grid2 item>
                                    <Grid2 item className='detailsHead'>Driver ID</Grid2>
                                    <Grid2 item className='detailsText'>{driverId}</Grid2>
                                </Grid2>
                                <Grid2 item>
                                    <Grid2 item className='detailsHead'>Mobile Number</Grid2>
                                    {showEditIcon && (
                                        <Grid2>
                                            <PhoneInput
                                                defaultCountry="IN"
                                                value={editedDriverPhone}
                                                onChange={(value) => {
                                                    setEditedDriverPhone(value);
                                                    try {
                                                    const parsed = parsePhoneNumber(value);
                                                    if (parsed) {
                                                        setEditedDriverCountryCode(parsed.countryCallingCode ? `+${parsed.countryCallingCode}` : '');
                                                    }
                                                    } catch (err) {
                                                    console.error('Invalid phone number:', err);
                                                    setEditedDriverCountryCode('');
                                                    }
                                                }}
                                                placeholder="Enter phone number"
                                                style={{
                                                    height: '38px', width:'164px',
                                                    fontSize: '16px',
                                                    alignItems: 'normal', marginTop:'1%'
                                                }}
                                            />
                                        </Grid2>
                                    )}
                                    {!showEditIcon && (
                                        <Grid2 item className='detailsText'>
                                        {driverDataShown == 0 ? driverPhone : (() => {
                                            if (!driverPhone) return '****';
                                            const phone = driverPhone;
                                            const cleanPhone = phone.replace(/\D/g, '');
                                            if (cleanPhone.length <= 4) return '****';
                                            const firstTwo = cleanPhone.substring(0, 2);
                                            const lastTwo = cleanPhone.substring(cleanPhone.length - 2);
                                            const maskedMiddle = '*'.repeat(cleanPhone.length - 4);
                                            return "+" + firstTwo + maskedMiddle + lastTwo;
                                        })()}</Grid2>
                                    )}
                                </Grid2>
                                <Grid2 item>
                                    <Grid2 item className='detailsHead'>Email</Grid2>
                                    {showEditIcon && (
                                        <Grid2>
                                            <TextField type="email"
                                                variant="outlined"
                                                value=
                                                {driverDataShown == 0 ? editedDriverEmail : (() => {
                                                    if (!editedDriverEmail) return '****';
                                                    const email = editedDriverEmail;
                                                    const atIndex = email.indexOf('@');
                                                    if (atIndex <= 2) return '****' + email.substring(atIndex);
                                                    const firstTwo = email.substring(0, 2);
                                                    const domain = email.substring(atIndex);
                                                    const maskedMiddle = '*'.repeat(atIndex - 2);
                                                    return firstTwo + maskedMiddle + domain;
                                                })()}
                                                onChange={(e) => {
                                                    handleEmailChange(e); // This already handles validation
                                                }}
                                                error={emailError}
                                                helperText={emailError ? "Valid email address is required" : ""}
                                                InputProps={{
                                                    inputProps: { min: 0 },
                                                    style: {
                                                        width:'160px',
                                                        height: '40px',
                                                        borderRadius:'8px',
                                                        fontSize: '16px',
                                                        padding: '14px 0px',
                                                        backgroundColor: '#FFFFFF',
                                                    },
                                                }}
                                            />
                                        </Grid2>
                                    )}
                                    {!showEditIcon && (
                                        <Grid2 item className='detailsText'>
                                        {driverDataShown == 0 ? driverEmail : (() => {
                                            if (!driverEmail) return '****';
                                            const email = driverEmail;
                                            const atIndex = email.indexOf('@');
                                            if (atIndex <= 2) return '****' + email.substring(atIndex);
                                            const firstTwo = email.substring(0, 2);
                                            const domain = email.substring(atIndex);
                                            const maskedMiddle = '*'.repeat(atIndex - 2);
                                            return firstTwo + maskedMiddle + domain;
                                        })()}</Grid2>
                                    )}
                                </Grid2>
                                <Grid2 item>
                                    <Grid2 item className='detailsHead'>Date of birth</Grid2>
                                        {!showEditIcon && (
                                            <Grid2 item className='detailsText'>{dayjs(driverDob).isValid() ? dayjs(driverDob).format('DD-MM-YYYY') : '-'}</Grid2>
                                        )}
                                        {showEditIcon && (
                                            <Grid2>
                                                <LocalizationProvider dateAdapter={AdapterDayjs} xs={{marginTop:'2%'}} >
                                                    <DatePicker
                                                        slotProps={{ 
                                                            textField: { 
                                                                size: 'medium',
                                                            } 
                                                        }}
                                                        sx={{
                                                            width: '140px',
                                                            '& .MuiInputBase-root': {
                                                                height: '40px',
                                                                borderRadius: '8px',
                                                                backgroundColor: '#FFFFFF'
                                                            }
                                                        }}
                                                        value={editedDriverDob && dayjs(editedDriverDob).isValid() ? dayjs(editedDriverDob) : null}
                                                        format={date_format_dd_mm_yy ? "DD-MM-YYYY" : "YYYY-MM-DD"}
                                                        onChange={(newValue) => {
                                                            setEditedDriverDob(newValue);
                                                        }}
                                                        maxDate={dayjs()}
                                                    />
                                                </LocalizationProvider>
                                            </Grid2>
                                        )}
                                    </Grid2>
                                <Grid2 item>
                                    <Grid2 item className='detailsHead'>Driver City</Grid2>
                                    <Grid2 item className='detailsText'>{(clientCities.find(city => city.city_id === location.state?.rowData.city_id)) ? (clientCities.find(city => city.city_id === location.state?.rowData.city_id)).city_name : '--'}</Grid2>
                                </Grid2>
                                <Grid2 item>
                                    <Grid2 item className='detailsHead'>Registered Date</Grid2>
                                    <Grid2 item className='detailsText'>{location.state?.rowData.registered_date ? (date_format_dd_mm_yy == '1' ? dayjs(location.state?.rowData.registered_date).format('DD-MM-YYYY') : dayjs(location.state?.rowData.registered_date).format('YYYY-MM-DD')) : '-'}</Grid2>
                                </Grid2>
                            </Grid2>

                        </Grid2>
                    </Grid2>

                    <Grid2 container sx={{mt:'2%'}}>
                        <Box sx={{ width: '100%' }}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider'}}>
                                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" sx={{borderRadius:'12px'}}>
                                    <Tab sx={{
                                        textTransform:'none',
                                        color: value === 0 ? 'white' : '#83888E', // Directly set color here
                                        '&.Mui-selected': { color: 'white', borderBottom:'' },
                                        backgroundColor: value===0 ? '#0065FF' : '#E6F0FF', 
                                        borderRadius: '6px 0px 0px 6px', marginLeft:'1%', width: '120px'
                                    }} label="Document" {...a11yProps(0)} />

                                    <Tab sx={{
                                        textTransform:'none',
                                        color: value===1 ? 'white' : '#83888E',
                                        '&.Mui-selected': { color: 'white' },
                                        backgroundColor: value===1 ? '#0065FF' : '#E6F0FF', 
                                        borderRadius: '0px 6px 6px 0px', width: '120px'
                                    }} onClick={fetchCarDetailsData} label="Car Details" {...a11yProps(1)} />

                                    {/* <Tab sx={{
                                        textTransform:'none',
                                        color: value===2 ? 'white' : '#83888E',
                                        '&.Mui-selected': { color: 'white' },
                                        backgroundColor: value===2 ? '#0065FF' : '#E6F0FF', 
                                        borderRadius: value==2 ? '6px' : '0px',
                                        // borderBottom: value === 2 ? '2px solid' : 'none',
                                        margin: value===2 ? '4px' :'0px'
                                    }} label="Driver Trips" {...a11yProps(2)} /> */}
                                </Tabs>
                            </Box>

                            <CustomTabPanel value={value} index={0}>
                                <Grid2 container className="innerTwo" sx={{padding:'12px', marginTop:'2%'}}>
                                    <Grid2 item sx={{backgroundColor:'#F9F9F9', width:'100%', padding:'1%', borderRadius:'8px'}}>
                                        <Typography>Profile Picture</Typography>
                                    </Grid2>
                                    
                                    <Grid2 item size={9.5} sx={{marginLeft:'2%'}}>
                                        <Grid2 item container>
                                            <Grid2 item size={2} sx={{marginTop:'1%'}}>
                                                <Box height='102px' width='102px' sx={{borderRadius:'12px'}}>
                                                    {/* <img src={defaultImg} alt="signup img" width='100px' height='100px' /> */}
                                                    {driverImage && (
                                                        <img src={driverImage} alt="profile" width='100px' height='100px'/>
                                                    )}
                                                    {driverImage=="" && (
                                                        <img src={altProfile} alt="alt profile" width='100px' height='100px'/>
                                                    )}
                                                </Box>
                                            </Grid2>

                                            {/* upload button is commented for now */}
                                            {/* <Grid2 item size={9} sx={{marginTop:'3%'}}>
                                                <Typography sx={{color:'#83888E', fontSize:'14px'}}>No Profile Picture Uploaded</Typography>
                                                <Button sx={{marginTop:'1%', border:1, borderColor:'#D1D5DB', borderRadius:'8px', textTransform:'none', color:'#83888E', width:'40%'}}>
                                                    <Typography>Upload</Typography>
                                                    <span style={{marginLeft:'auto'}}><NoteAddIcon/></span>
                                                </Button>
                                            </Grid2> */}
                                        </Grid2>
                                    </Grid2>
                                </Grid2>

                                {/* code for documents is commented for now */}
                                <Grid2 container className="innerTwo" sx={{ padding: '12px', marginTop: '2%' }}>
                                    <Grid2 item sx={{ backgroundColor: '#F9F9F9', width: '100%', padding: '1%', borderRadius: '8px' }}>
                                        <Typography>Documents</Typography>
                                    </Grid2>

                                    <Grid2 item size={12} sx={{ marginLeft: '2%', mb: '2%' }}>
                                        {/* Loop through the driver documents */}
                                        {driverDocumentsData?.map((doc, index) => (
                                            <Grid2 container sx={{ padding: '12px', marginTop: '2%' }} key={`driver-doc-${doc.document_id}-${index}`}>
                                                
                                                <Grid2 item sx={{ backgroundColor: '#F9F9F9', width: '100%', padding: '1%', borderRadius: '8px', display: 'flex' }}>
                                                    <Typography sx={{display: 'flex', alignItems: 'center', height: '100%'}}>{doc.document_name}</Typography>
                                                    <Typography sx={{color:'#0065FF', border:'1px solid #D1D5DB', borderRadius:'6px', padding:'3px 8px', marginLeft:'auto'}}>{doc.document_number}</Typography>
                                                </Grid2>

                                                <Grid2 item size={12} sx={{ marginLeft: '2%', mb: '2%', alignItems:'center' }}>
                                                    {/* Document images */}
                                                    <Grid2 container spacing={4} alignItems='center'>
                                                        {(doc.images.split(';;;;'))?.map((image, imageIndex) => (
                                                            <Grid2 
                                                                item 
                                                                size={2} 
                                                                sx={{ marginTop: '1%', textAlign: 'center' }} 
                                                                key={`driver-doc-${doc.document_id}-${imageIndex}`}
                                                            >
                                                                <Box 
                                                                    height='102px' 
                                                                    width='102px' 
                                                                    sx={{ 
                                                                        borderRadius: '12px', 
                                                                        overflow: 'hidden', 
                                                                        border: '2px solid #0065FF', 
                                                                        display: 'flex', 
                                                                        justifyContent: 'center', 
                                                                        alignItems: 'center',
                                                                        cursor: 'pointer'
                                                                    }}
                                                                    // onClick={() => handleImageOpen(image || defaultImg)}
                                                                >
                                                                    {image ? (
                                                                        <img src={image} alt={`doc image ${imageIndex}`} width='100%' height='100%'
                                                                        style={{
                                                                            maxWidth: '100%',
                                                                            maxHeight: '100%',
                                                                            objectFit: 'contain',
                                                                            // transform: `rotate(${rotation}deg)`,
                                                                            transition: 'transform 0.3s ease',
                                                                            cursor: 'pointer'
                                                                        }} />
                                                                    ) : (
                                                                        <img src={defaultImg} alt="default image" width='100%' height='100%' />
                                                                    )}
                                                                </Box>

                                                                <Grid2>
                                                                    <VisibilityIcon sx={{
                                                                        cursor: 'pointer',marginTop: '8px',
                                                                        color: '#0065FF',fontSize: '24px'
                                                                        }} 
                                                                        onClick={() => handleImageOpen(image || defaultImg)}
                                                                    />
                                                                    {/* Label for Front and Back */}
                                                                    <Typography sx={{ marginTop: '4px', fontSize: '12px', color: '#83888E' }}>
                                                                        {imageIndex === 0 ? 'Front' : 'Back'}
                                                                    </Typography>
                                                                </Grid2>
                                                                
                                                            </Grid2>
                                                        ))}

                                                        {/* Modal for Image */}
                                                        <Modal open={open} onClose={handleImageClose}
                                                            sx={{display: 'flex',justifyContent: 'center',alignItems: 'center'}}>

                                                            <Box
                                                                sx={{
                                                                    position: 'relative', width: '90vw', height: '90vh',
                                                                    maxWidth: '500px', maxHeight: '500px', borderRadius: '12px',
                                                                    overflow: 'hidden', backgroundColor: 'white',
                                                                    display: 'flex',justifyContent: 'center', alignItems: 'center'
                                                                }}
                                                            >
                                                                <img
                                                                    src={currentImage}
                                                                    alt="Magnified Document"
                                                                    onClick={() => setRotation(prev => prev + 90)}
                                                                    style={{
                                                                        maxWidth: '100%',
                                                                        maxHeight: '100%',
                                                                        objectFit: 'contain',
                                                                        transform: `rotate(${rotation}deg)`,
                                                                        transition: 'transform 0.3s ease',
                                                                        cursor: 'pointer'
                                                                    }}
                                                                />
                                                                <IconButton
                                                                    onClick={() => setRotation(prev => (prev + 90) % 360)}
                                                                    sx={{
                                                                        position: 'absolute',
                                                                        top: 10,
                                                                        right: 10,
                                                                        backgroundColor: '#fff',
                                                                        boxShadow: 2,
                                                                        '&:hover': { backgroundColor: '#f5f5f5' }
                                                                    }}
                                                                >
                                                                    <RotateRightIcon />
                                                                </IconButton>
                                                            </Box>
                                                        </Modal>

                                                        {/* Document status and reject/approve buttons */}
                                                        <Grid2 item size={4} sx={{ marginTop: '3%', marginLeft:'8%' }}>
                                                            {doc.status === 1 && (
                                                                <Grid2 item>
                                                                    <Grid2 item sx={{ marginBottom: '2%'}}>
                                                                        <img src={verifiedTick} width="36px" height="36px" alt="verified tick"/>
                                                                    </Grid2>
                                                                    <Grid2 item>
                                                                        <Typography sx={{ color: '#0DBA78', fontSize: '14px' }}>{doc.document_name} Approved</Typography>
                                                                    </Grid2>
                                                                </Grid2>
                                                            )}

                                                            {doc.status === 3 && (
                                                                <Grid2 item>
                                                                <Grid2 item sx={{marginBottom: '2%'}}>
                                                                    <img src={rejectedCross} width="36px" height="36px" alt="rejected cross"/>
                                                                </Grid2>
                                                                <Grid2 item>
                                                                    <Typography sx={{ color: '#C71F1F', fontSize: '14px' }}>{doc.document_name} Rejected</Typography>
                                                                    <Typography sx={{ color: '#83888E', fontSize: '14px' }}> (  {doc.reason}  )</Typography>
                                                                </Grid2>
                                                            </Grid2>
                                                            )}

                                                            {doc.status === 4 && (
                                                                <Grid2 item>
                                                                <Grid2 item>
                                                                    <Typography sx={{ color: '#C71F1F', fontSize: '14px' }}>{doc.document_name} Expired</Typography>
                                                                </Grid2>
                                                            </Grid2>
                                                            )}

                                                            {doc.status === 5 && (
                                                                <Grid2 item>
                                                                <Grid2 item>
                                                                    <Typography sx={{ color: '#F5BB19', fontSize: '14px' }}>{doc.document_name} Expiring Soon</Typography>
                                                                </Grid2>
                                                            </Grid2>
                                                            )}

                                                            {doc.status === 2 && (
                                                                <Grid2 container sx={{ gap: '8px', display: 'flex', marginTop:'4%' }}>
                                                                    <Grid2 item>
                                                                        <Button
                                                                            variant="contained"
                                                                            sx={{ backgroundColor: '#0DBA78', width: '120px' }}
                                                                            onClick={() => handleRejectSubmit(doc.document_id, null, 1, 'driver')} // Directly approve here
                                                                        >
                                                                            Approve
                                                                        </Button>
                                                                    </Grid2>
                                                                    <Grid2 item>
                                                                        <Button
                                                                            variant="contained"
                                                                            sx={{ backgroundColor: '#C71F1F', width: '120px' }}
                                                                            onClick={() => handleRejectModal(doc.document_id, null, 3, 'driver')}
                                                                        >
                                                                            Reject
                                                                        </Button>
                                                                    </Grid2>
                                                                </Grid2>
                                                            )}
                                                        </Grid2>

                                                        {doc.expiry_date && 
                                                            <Grid2 item size={3} sx={{marginLeft:'auto', gap: 1}}>
                                                                <>
                                                                    <Grid2 item className='detailsHead'>Expiry Date:</Grid2>
                                                                    {editingDocId !== doc.document_id ? (
                                                                        <Grid2 item className='detailsText' sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                            {dayjs(doc.expiry_date).isValid() ? dayjs(doc.expiry_date).format('DD-MM-YYYY') : '-'}
                                                                            <IconButton 
                                                                                size="small" 
                                                                                onClick={() => {
                                                                                    setEditingDocId(doc.document_id);
                                                                                    setEditedDriverExpireDate(doc.expiry_date);
                                                                                }}
                                                                                sx={{ color: 'primary.main' }}
                                                                            >
                                                                                <EditIcon fontSize="small" />
                                                                            </IconButton>
                                                                        </Grid2>
                                                                    ) : (
                                                                        <Grid2 container direction="column" spacing={1}>
                                                                            <Grid2 item>
                                                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                                    <DatePicker
                                                                                        slotProps={{ 
                                                                                            textField: { 
                                                                                                size: 'medium',
                                                                                            } 
                                                                                        }}
                                                                                        sx={{
                                                                                            width: '140px',
                                                                                            '& .MuiInputBase-root': {
                                                                                                height: '40px',
                                                                                                borderRadius: '8px',
                                                                                                backgroundColor: '#FFFFFF'
                                                                                            }
                                                                                        }}
                                                                                        value={editedDriverExpireDate && dayjs(editedDriverExpireDate).isValid() ? dayjs(editedDriverExpireDate) : null}
                                                                                        format={date_format_dd_mm_yy ? "DD-MM-YYYY" : "YYYY-MM-DD"}
                                                                                        onChange={(newValue) => {
                                                                                            setEditedDriverExpireDate(newValue);
                                                                                        }}
                                                                                        // maxDate={dayjs()}
                                                                                    />
                                                                                </LocalizationProvider>
                                                                            </Grid2>
                                                                            <Grid2 item sx={{ display: 'flex', justifyContent: 'flex-start', gap: 1, mt: 1, width: '100%' }}>
                                                                                <Button 
                                                                                    onClick={() => handleExpireDateSubmit(doc.document_id)}
                                                                                    variant="contained"
                                                                                    sx={{
                                                                                        backgroundColor: '#0065FF',
                                                                                        color: '#fff',
                                                                                        textTransform: 'none',
                                                                                        borderRadius: '6px',
                                                                                        minWidth: '80px', 
                                                                                        height: '32px',
                                                                                        fontSize: '0.875rem',
                                                                                        fontWeight: 500,
                                                                                        '&:hover': {
                                                                                            backgroundColor: '#0052cc',
                                                                                            boxShadow: 'none'
                                                                                        },
                                                                                        boxShadow: 'none',
                                                                                        px: 2,
                                                                                    }}
                                                                                >
                                                                                    Save
                                                                                </Button>
                                                                                <Button 
                                                                                    onClick={() => setEditingDocId(null)}
                                                                                    variant="outlined"
                                                                                    sx={{
                                                                                        color: '#6B7280',
                                                                                        borderColor: '#D1D5DB',
                                                                                        textTransform: 'none',
                                                                                        borderRadius: '6px',
                                                                                        minWidth: '80px',
                                                                                        height: '32px',
                                                                                        fontSize: '0.875rem',
                                                                                        fontWeight: 500,
                                                                                        '&:hover': {
                                                                                            backgroundColor: '#F9FAFB',
                                                                                            borderColor: '#9CA3AF',
                                                                                        },
                                                                                        px: 2,
                                                                                    }}
                                                                                >
                                                                                    Cancel
                                                                                </Button>
                                                                            </Grid2>
                                                                        </Grid2>
                                                                    )}

                                                                </>
                                                                
                                                            </Grid2>
                                                        }
                                                    </Grid2>

                                                    
                                                </Grid2>
                                            </Grid2>
                                        ))}
                                    </Grid2>
                                </Grid2>
                            </CustomTabPanel>

                            <CustomTabPanel value={value} index={1}>
                                {vehicleDecouplingEnabled == 1 &&
                               <Grid2
                                    sx={{
                                        mt: "auto",
                                        mb: "3%",
                                        border: multipleVehicletoggle ? "1px solid #0DBA78" : "1px solid #E3E5E8",
                                        margin: "2% 0%",
                                        borderRadius: "12px",
                                        p: "1.5%",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        boxShadow: multipleVehicletoggle ? "0px 2px 4px rgba(0, 0, 0, 0.1)" : "none",
                                    }}
                                    >
                                    {/* Left content */}
                                     <Grid2>
                                        <Typography
                                        sx={{ color: "#2A313C", fontWeight: 500, fontSize: "20px" }}
                                        >
                                        Multiple Vehicle Option
                                        </Typography>

                                        <Typography
                                        sx={{ color: "#4E545D", fontWeight: 500, fontSize: "16px" }}
                                        >
                                        Enable or disable the driver's ability to add and manage multiple vehicles
                                        </Typography>
                                    </Grid2>

                                    {/* Right toggle section */}
                                    <Grid2
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                    }}
                                    >
                                        <Typography>
                                            {multipleVehicletoggle ? 'Enabled' : 'Disabled'}
                                        </Typography>
                                        <CustomSwitch
                                            backgroundtheme="#0DBA78"
                                            checked={multipleVehicletoggle}
                                            onChange={(e) => setMultipleVehicletoggle(e.target.checked)}
                                            />

                                    </Grid2>
                                    </Grid2>}

                                {(carDetailsData)?.map((vehicleDetails , index) => (
                                    // <Grid2 className="innerOne" sx={{bgcolor:'#FFFFFF', marginTop:'2%',padding:'1%', borderRadius:'16px',position:'relative',border: vehicleDetails.status == -1 ? '1px solid #D14545' : '1px solid #D1D5DB'}}>
                                            <Accordion 
                                            key={vehicleDetails.vehicle_id}
                                            sx={{ 
                                                bgcolor:'#FFFFFF', 
                                                marginTop:'2%', 
                                                borderRadius:'16px !important',
                                                border: vehicleDetails.status == -1 ? '1px solid #D14545' : '1px solid #D1D5DB',
                                                '&:before': {
                                                    display: 'none', // Remove default MUI accordion border
                                                }
                                            }}
                                        >
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                sx={{ 
                                                    padding: '1%',
                                                    borderRadius: '16px',
                                                    '&.Mui-expanded': {
                                                        minHeight: 'auto',

                                                    }
                                                }}
                                            >
                                        <Grid2 container sx={{ bgcolor:''}}>
                                            <Grid2 item sx={{margin:'20px'}}>
                                                <Box sx={{display:'flex',bgcolor:'#F9F9F9',borderRadius:'12px'}}>
                                                    <Grid2>
                                                        {vehicleDetails.vehicle_image && (
                                                            <img  src={vehicleDetails.vehicle_image || DefaultCar} alt="profile" width='120px' height='120px'/>
                                                        )}
                                                        {!vehicleDetails.vehicle_image && (
                                                            <img  src={DefaultCar} alt="alt profile" width='120px' height='120px'/>
                                                        )}
                                                    </Grid2>
                                                </Box>
                                            </Grid2>

                                            <Grid2
                                                sx={{
                                                    marginTop: "auto",
                                                    marginRight: "18px",
                                                    ml: "18px",
                                                    mb: "3%",
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                }}
                                            >
                                            <Grid2 sx={{ flex: 1 }}>
                                                <Grid2 sx={{ mb: "2%", mt: "2%", display: "flex", alignItems: "center" }}>
                                                <Typography sx={{ p: 0.5 }}>Vehicle Details</Typography>
                                                {vehicleDetails?.is_default_vehicle == '1' && <Typography
                                                    sx={{
                                                    ml: "5%",
                                                    background: "#F3F8FF",
                                                    color: "#0065FF",
                                                    py: 0.5,
                                                    px: 2,
                                                    borderRadius: "12px",
                                                    }}
                                                >
                                                    Primary
                                                </Typography>}
                                                </Grid2>

                                                <Grid2 container spacing={10}>

                                                 <Grid2 item>
                                                    <Grid2 className="detailsHead">Vehicle Name</Grid2>
                                                    <Grid2 className="detailsText">
                                                    {vehicleDetails.vehicle_type_name}
                                                    </Grid2>
                                                </Grid2>

                                                <Grid2 item>
                                                    <Grid2 className="detailsHead">Vehicle Number</Grid2>
                                                    <Grid2 className="detailsText">
                                                    {vehicleDetails.vehicle_no || vehicleDetails.vehicle_number}
                                                    </Grid2>
                                                </Grid2>

                                                <Grid2 item>
                                                    <Grid2 className="detailsHead">Vehicle Type</Grid2>
                                                    <Grid2 className="detailsText">
                                                    {vehicleDetails.vehicle_type === 1
                                                        ? "Taxi"
                                                        : vehicleDetails.vehicle_type === 2
                                                        ? "Bike"
                                                        : vehicleDetails.vehicle_type === 3
                                                        ? "Auto"
                                                        : vehicleDetails.vehicle_type === 4
                                                        ? "Shuttle"
                                                        : "Unknown"}
                                                    </Grid2>
                                                </Grid2>
                                                {vehicleDetails.offering_type && <Grid2 item>
                                                    <Grid2 className="detailsHead">Offering Type</Grid2>
                                                    <Grid2 className="detailsText">
                                                    {vehicleDetails.offering_type === 1
                                                        ? "Taxi"
                                                        : vehicleDetails.offering_type === 2
                                                        ? "Deliver"
                                                        : vehicleDetails.offering_type === 3
                                                        ? "Taxi and Delivery"
                                                        : " "}
                                                    </Grid2>
                                                </Grid2>}
                                                {driver_vehicle_attachment_enabled == "0" && (
                                                    <Grid2 item>
                                                    <Grid2 className="detailsHead">Status</Grid2>
                                                    <Grid2
                                                        className="detailsText"
                                                        sx={{
                                                        color:
                                                            vehicleDetails.status === 1
                                                            ? "#0DBA78"
                                                            : vehicleDetails.status === 0 || vehicleDetails.status === 4
                                                            ? "#F5BB19"
                                                            : "#D14545",
                                                        }}
                                                    >
                                                        {vehicleDetails.status == 1
                                                        ? "✔ Verified"
                                                        : vehicleDetails.status == 0
                                                        ? "Pending" 
                                                        : vehicleDetails.status == -1
                                                        ? " X Deleted"
                                                        : vehicleDetails.status == 2
                                                        ? " Rejected"
                                                        : vehicleDetails.status == 3
                                                        ? " Expired"
                                                        : vehicleDetails.status == 4
                                                        ? " Expiring soon"
                                                        : ""}
                                                    </Grid2>
                                                    </Grid2>
                                                )}
                                                </Grid2>
                                            </Grid2>

                                            <Grid2
                                                sx={{
                                                    position: "absolute",
                                                    top: "16px",
                                                    right: "16px",
                                                    display: "flex",
                                                    alignItems: "center", // Changed from "flex-end" to "center" for better alignment
                                                    gap: "8px",
                                                    zIndex: 10,
                                                }}
                                            >
                                                {/* Set as Primary */}
                                                {vehicleDetails.is_default_vehicle != 1 && vehicleDetails?.status != -1 && vehicleDetails?.status != 0 && vehicleDetails?.status != 2 && (
                                                    <Button
                                                        size="small"
                                                        sx={{
                                                            textTransform: "none",
                                                            borderRadius: "6px",
                                                            border: '1px solid #0065FF',
                                                            whiteSpace: "nowrap",
                                                            color: '#0065FF'
                                                        }}
                                                        onClick={() => handleDefaultVehicleset(vehicleDetails.vehicle_id)}
                                                    >
                                                        ✔ Set as Primary
                                                    </Button>
                                                )}
                                                
                                                {vehicleDetails.is_default_vehicle != 1 && vehicleDetails?.status != -1 && (
                                                    <Grid2
                                                        sx={{
                                                            border: "1px solid #D1D5DB",
                                                            borderRadius: "6px",
                                                            padding: "6px",
                                                            cursor: "pointer",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            bgcolor: "#fff",
                                                        }}
                                                        onClick={(event) => {
                                                            handleMenuOpen(event);
                                                            setDeleteVehicleId(vehicleDetails.vehicle_id);
                                                        }}
                                                    >
                                                        <img src={threedots} alt="menu" />
                                                    </Grid2>
                                                )}
                                            </Grid2>


                                            </Grid2>
                                        </Grid2>
                                        </AccordionSummary>
                                        <AccordionDetails sx={{ padding: '0 24px 24px' }}>
                                        {(vehicleDetails.document_details)?.map((doc, index) => (
                                            <Grid2 container sx={{ padding: '12px', marginTop: '2%',bgcolor:'#FAFAFA',borderRadius:'12px'}} key={`vehicle-doc-${doc.document_id}-${index}`}>
                                            <Grid2 item sx={{ backgroundColor: '#fff', width: '100%', padding: '1%', borderRadius: '8px', display: 'flex' }}>
                                                <Typography sx={{display: 'flex', alignItems: 'center', height: '100%'}}>{doc.document_name}</Typography>
                                                <Grid2 item sx={{marginLeft:'auto'}}>
                                                   {doc.document_number && <Typography sx={{color:'#0065FF', border:'1px solid #D1D5DB', borderRadius:'6px', padding:'3px 8px'}}>{doc.document_number}</Typography>}
                                                </Grid2>
                                                
                                            </Grid2>

                                            <Grid2 item size={9.5} sx={{ marginLeft: '2%', mb: '2%' }}>
                                                <Grid2
                                                    container
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "flex-start",
                                                        width: "100%",
                                                    }}
                                                    >

                                                    {(doc.images.split(';;;;'))?.map((image, imageIndex) => (
                                                        <Grid2 
                                                            item 
                                                            size={2} 
                                                            sx={{ marginTop: '1%', textAlign: 'center' }} 
                                                            key={`driver-doc-${doc.document_id}-${imageIndex}`}
                                                        >
                                                            <Box 
                                                                height='102px' 
                                                                width='102px' 
                                                                sx={{ 
                                                                    borderRadius: '12px', 
                                                                    overflow: 'hidden', 
                                                                    border: '2px solid #0065FF', 
                                                                    display: 'flex', 
                                                                    justifyContent: 'center', 
                                                                    alignItems: 'center'
                                                                }}
                                                                // onClick={() => handleImageOpen(image || defaultImg)}
                                                            >
                                                                {image ? (
                                                                    <img src={image} alt={`doc image ${imageIndex}`} width='100%' height='100%' />
                                                                ) : (
                                                                    <img src={defaultImg} alt="default image" width='100%' height='100%' />
                                                                )}
                                                            </Box>
                                                            <Grid2 item>
                                                                <VisibilityIcon sx={{
                                                                    cursor: 'pointer',marginTop: '8px',
                                                                    color: '#0065FF',fontSize: '24px'
                                                                    }} 
                                                                    onClick={() => handleImageOpen(image || defaultImg)}
                                                                />
                                                                <Typography sx={{ marginTop: '4px', fontSize: '12px', color: '#83888E' }}>
                                                                    {imageIndex === 0 ? 'Front' : 'Back'}
                                                                </Typography>
                                                            </Grid2>
                                                            
                                                        </Grid2>
                                                    ))}

                                                    <Modal open={open} onClose={handleImageClose}
                                                        sx={{display: 'flex',justifyContent: 'center',alignItems: 'center'}}>

                                                        <Box
                                                            sx={{
                                                                position: 'relative', width: '90vw', height: '90vh',
                                                                maxWidth: '500px', maxHeight: '500px', borderRadius: '12px',
                                                                overflow: 'hidden', backgroundColor: 'white',
                                                                display: 'flex',justifyContent: 'center', alignItems: 'center'
                                                            }}
                                                        >
                                                            <img
                                                                src={currentImage}
                                                                alt="Magnified Document"
                                                                onClick={() => setRotation(prev => prev + 90)}
                                                                style={{maxWidth:'100%', maxHeight:'100%', objectFit:'contain', transform: `rotate(${rotation}deg)`,
                                                                    transition: 'transform 0.3s ease',
                                                                    cursor: 'pointer'}}
                                                            />
                                                        </Box>
                                                    </Modal>

                                                    <Grid2
                                                        item
                                                        sx={{
                                                            marginLeft: "auto",
                                                            marginTop: "3%",
                                                            minWidth: "20px",
                                                            textAlign: "right",
                                                        }}
                                                        >
                                                        {doc.status === 1 && (
                                                            <Grid2 item>
                                                                <Grid2 item sx={{ marginBottom: '2%', justifyItems:'center'}}>
                                                                    <img src={verifiedTick} width="36px" height="36px" alt="verified tick" style={{display:'flex'}} />
                                                                </Grid2>
                                                                <Grid2 item>
                                                                    <Typography sx={{ color: '#0DBA78', fontSize: '14px' }}>{doc.document_name} Approved</Typography>
                                                                </Grid2>
                                                            </Grid2>
                                                            // <Typography sx={{ color: '#0DBA78', fontSize: '14px' }}>Document Approved</Typography>
                                                        )}

                                                        {doc.status === 3 && (
                                                            <Grid2 item>
                                                                <Grid2 item sx={{marginBottom: '2%', justifyItems:'center' }}>
                                                                    <img src={rejectedCross} width="36px" height="36px" alt="rejected cross" style={{display:'flex'}} />
                                                                </Grid2>
                                                                <Grid2 item>
                                                                    <Typography sx={{ color: '#C71F1F', fontSize: '14px' }}>{doc.document_name} Rejected</Typography>
                                                                    <Typography sx={{ color: '#83888E', fontSize: '14px' }}> (  {doc.reason}  )</Typography>
                                                                </Grid2>
                                                            </Grid2>
                                                            // <Typography sx={{ color: '#C71F1F', fontSize: '14px' }}>Document Rejected</Typography>
                                                        )}

                                                        {doc.status === 4 && (
                                                            <Grid2 item>
                                                                <Typography sx={{ color: '#C71F1F', fontSize: '14px' }}>{doc.document_name} Expired</Typography>
                                                            </Grid2>
                                                        )}

                                                        {doc.status === 5 && (
                                                            <Grid2 item>
                                                                <Typography sx={{ color: '#F5BB19', fontSize: '14px' }}>{doc.document_name} Expiring Soon</Typography>
                                                            </Grid2>
                                                        )}

                                                        {doc.status === 2 && ( // If document status is "Pending"
                                                            <Grid2 container sx={{ gap: '8px', display: 'flex' }}>
                                                                <Grid2 item>
                                                                    <Button
                                                                        variant="contained"
                                                                        sx={{ backgroundColor: '#0DBA78', width: '120px' }}
                                                                        onClick={() => handleRejectSubmit(doc.document_id, vehicleDetails.vehicle_id, 1, 'vehicle')} // Directly call handleRejectSubmit with status 1 for approval
                                                                    >
                                                                        Approve
                                                                    </Button>
                                                                </Grid2>


                                                                <Grid2 item>
                                                                    <Button
                                                                        variant="contained"
                                                                        sx={{ backgroundColor: '#C71F1F', width: '120px' }}
                                                                        onClick={() => handleRejectModal(doc.document_id, vehicleDetails.vehicle_id, 3, 'vehicle')} // Open the reject modal with status 3
                                                                    >
                                                                        Reject
                                                                    </Button>
                                                                </Grid2>
                                                            </Grid2>
                                                        )}
                                                    </Grid2>

                                                    {doc.expiry_date && 
                                                        <Grid2 item size={3} sx={{marginLeft:'auto', gap: 1}}>
                                                            <>
                                                                <Grid2 item className='detailsHead'>Expiry Date:</Grid2>
                                                                {editingDocId !== doc.document_id ? (
                                                                    <Grid2 item className='detailsText' sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                        {dayjs(doc.expiry_date).isValid() ? dayjs(doc.expiry_date).format('DD-MM-YYYY') : '-'}
                                                                        <IconButton 
                                                                            size="small" 
                                                                            onClick={() => {
                                                                                setEditingDocId(doc.document_id);
                                                                                setEditedDriverExpireDate(doc.expiry_date);
                                                                            }}
                                                                            sx={{ color: 'primary.main' }}
                                                                        >
                                                                            <EditIcon fontSize="small" />
                                                                        </IconButton>
                                                                    </Grid2>
                                                                ) : (
                                                                    <Grid2 container direction="column" spacing={1}>
                                                                        <Grid2 item>
                                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                                <DatePicker
                                                                                    slotProps={{ 
                                                                                        textField: { 
                                                                                            size: 'medium',
                                                                                        } 
                                                                                    }}
                                                                                    sx={{
                                                                                        width: '140px',
                                                                                        '& .MuiInputBase-root': {
                                                                                            height: '40px',
                                                                                            borderRadius: '8px',
                                                                                            backgroundColor: '#FFFFFF'
                                                                                        }
                                                                                    }}
                                                                                    value={editedDriverExpireDate && dayjs(editedDriverExpireDate).isValid() ? dayjs(editedDriverExpireDate) : null}
                                                                                    format={date_format_dd_mm_yy ? "DD-MM-YYYY" : "YYYY-MM-DD"}
                                                                                    onChange={(newValue) => {
                                                                                        setEditedDriverExpireDate(newValue);
                                                                                    }}
                                                                                    // maxDate={dayjs()}
                                                                                />
                                                                            </LocalizationProvider>
                                                                        </Grid2>
                                                                        <Grid2 item sx={{ display: 'flex', justifyContent: 'flex-start', gap: 1, mt: 1, width: '100%' }}>
                                                                            <Button 
                                                                                onClick={() => handleExpireDateSubmit(doc.document_id, vehicleDetails.vehicle_id)}
                                                                                variant="contained"
                                                                                sx={{
                                                                                    backgroundColor: '#0065FF',
                                                                                    color: '#fff',
                                                                                    textTransform: 'none',
                                                                                    borderRadius: '6px',
                                                                                    minWidth: '80px', 
                                                                                    height: '32px',
                                                                                    fontSize: '0.875rem',
                                                                                    fontWeight: 500,
                                                                                    '&:hover': {
                                                                                        backgroundColor: '#0052cc',
                                                                                        boxShadow: 'none'
                                                                                    },
                                                                                    boxShadow: 'none',
                                                                                    px: 2,
                                                                                }}
                                                                            >
                                                                                Save
                                                                            </Button>
                                                                            <Button 
                                                                                onClick={() => setEditingDocId(null)}
                                                                                variant="outlined"
                                                                                sx={{
                                                                                    color: '#6B7280',
                                                                                    borderColor: '#D1D5DB',
                                                                                    textTransform: 'none',
                                                                                    borderRadius: '6px',
                                                                                    minWidth: '80px',
                                                                                    height: '32px',
                                                                                    fontSize: '0.875rem',
                                                                                    fontWeight: 500,
                                                                                    '&:hover': {
                                                                                        backgroundColor: '#F9FAFB',
                                                                                        borderColor: '#9CA3AF',
                                                                                    },
                                                                                    px: 2,
                                                                                }}
                                                                            >
                                                                                Cancel
                                                                            </Button>
                                                                        </Grid2>
                                                                    </Grid2>
                                                                )}

                                                            </>
                                                            
                                                        </Grid2>
                                                    }
                                                </Grid2>

                                                
                                            </Grid2>
                                        </Grid2>
                                        ))}
                                        </AccordionDetails>
                                        </Accordion>
                                    // {/* </Grid2> */}
                                ))}

                                {driver_vehicle_attachment_enabled=="1" && openAttachmentVehicle && availableVehicle.length>0 && (
                                    <>
                                        <Grid2 item sx={{marginTop:'2%'}}>
                                            <Label>Select Vehicle<span style={{ color: 'red' }}>*</span></Label>
                                            <Select
                                            value={newDriverVehicle}
                                            onChange={(e) => setNewDriverVehicle( e.target.value)} 
                                            displayEmpty fullWidth
                                            style={{ height: '50px', borderRadius: '8px', backgroundColor: '#FFFFFF', marginTop:'1%'}}>
                                                <MenuItem value="">Select Vehicle</MenuItem>
                                                {availableVehicle?.map((vehicle) => (
                                                    <MenuItem key={vehicle.vehicle_id} value={vehicle.vehicle_id}>
                                                        {vehicle.vehicle_number}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Grid2>

                                        <Grid2 item sx={{marginTop:'2%'}}>
                                            <Button onClick={attachVehicleById} variant='contained'>Done</Button>
                                        </Grid2>
                                    </>
                                )}
                                {driver_vehicle_attachment_enabled=="1" && (
                                    <Grid2 sx={{marginTop:'2%'}}>
                                        {carDetailsData.length==0 && isAttachmentEnabled == 1 && !openAttachmentVehicle && (
                                            <Button variant="contained" sx={{textTransform:'none', float:'right', backgroundColor:'#0DBA78'}} onClick={attachVehicle}>Attach Vehicle</Button>
                                        )}
                                        {carDetailsData.length>0 && isAttachmentEnabled == 1 && (
                                            <Button variant="contained" sx={{textTransform:'none', float:'right', backgroundColor:'#D14545'}} onClick={detachVehicle}>Detach Vehicle</Button>
                                        )}
                                    </Grid2>
                                )}
                            </CustomTabPanel>

                            <CustomTabPanel value={value} index={2}>
                                {/* Item Three */}
                            </CustomTabPanel>
                        </Box>
                    </Grid2>
                </Grid2>


                {rejectModal && (
                    <>
                        {/* Backdrop Overlay */}
                        <div 
                            style={{
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                zIndex: 999,  // Make sure the overlay is below the modal
                            }}
                            onClick={onClose} // Close modal if clicked anywhere outside the modal
                        />
                        
                        {/* Modal */}
                        <div style={{
                            position: 'fixed', top:'4px', right:0, height:'100%',
                            width: '580px',
                            zIndex: 1000,
                            backgroundColor: '#F9F9F9',
                            // marginLeft: '58%',
                            padding: '2%',
                            height: '100vh',
                            borderRadius: '12px',
                        }}>
                            <IconButton
                                aria-label="close"
                                onClick={onClose}
                                style={{
                                    position: 'absolute',
                                    top: '-15px',
                                    left: '1px',
                                    color: '#333',
                                    zIndex: 10,
                                    paddingTop: '18px'
                                }}
                            >
                                <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                            </IconButton>

                            <Typography variant="body1" sx={{ color: '#4A4A4A', paddingTop: '6%', fontSize: '24px' }}>
                                Select Reason
                            </Typography>

                            <Grid2 style={{ maxWidth: '580px', margin: '0', backgroundColor: '#FFFFFF', borderRadius: '12px' }}>
                                <div style={{
                                    alignItems: 'center',
                                    backgroundColor: '#fff',
                                    padding: '10px',
                                    borderRadius: '8px',
                                    marginTop: '30px'
                                }}>
                                    <Typography
                                        variant="body1"
                                        style={{
                                            color: '#1A1E25',
                                            fontWeight: '500',
                                            fontSize: '20px',
                                            paddingLeft: '4%'
                                        }}
                                    >
                                        Select Reason
                                    </Typography>

                                    <FormControl sx={{ marginLeft: '20px', marginTop: '2%' }}>
                                        <RadioGroup
                                            defaultValue=""
                                            name="controlled-radio-buttons-group"
                                            value={rejectValue}
                                            onChange={handleRejectChange}
                                        >
                                            <FormControlLabel sx={{ fontSize: '16px' }} value="Wrong Document" control={<Radio />} label="Wrong Document" />
                                            <FormControlLabel sx={{ fontSize: '16px' }} value="Image not clear" control={<Radio />} label="Image not clear" />
                                            <FormControlLabel sx={{ fontSize: '16px' }} value="other" control={<Radio />} label="Other" />
                                        </RadioGroup>
                                    </FormControl>

                                    <div style={{ marginLeft: '20px', marginTop: '18px' }}>
                                        <textarea
                                            name="Outlined"
                                            value={customReason}
                                            onChange={handleTextAreaChange}
                                            placeholder="Type in here…"
                                            style={{
                                                width: '90%',
                                                height: '100px',
                                                borderRadius: '8px',
                                                padding: '10px',
                                                borderColor: '#D1D5DB'
                                            }}
                                        />
                                    </div>

                                    <div style={{ marginTop: '18px', textAlign: 'center' }}>
                                        <Button
                                            variant='contained'
                                            className='actionButton'
                                            sx={{ ml: '4%', backgroundColor: '#C71F1F' }}
                                            onClick={() => {
                                                handleRejectSubmit(modalData.documentId, modalData.vehicleId, modalData.status, modalData.docType, customReason ? customReason : rejectValue);
                                                onClose(); // Close modal after rejection
                                            }}
                                            disabled={!customReason && !rejectValue}
                                        >
                                            Reject
                                        </Button>
                                    </div>

                                </div>
                            </Grid2>
                        </div>
                    </>
                )}
            </div>
            <Menu
                anchorEl={anchorEl}
                open={openMenu}
                onClose={handleMenuClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                >
                <MenuItem
                    onClick={() => handleDelete()}
                    sx={{ color: "#C71F1F" }}
                >
                    Delete
                </MenuItem>
                </Menu>


            <Snackbar open={snackbar} autoHideDuration={2000} onClose={() => showSnackbar(false)} message={message}></Snackbar>

        </div>
    );
};

export default DriverDetails;
